import {
  alpha,
  Box,
  Button,
  IconButton,
  Stack,
  Tooltip,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import { Event } from "@mui/icons-material";
import BookmarkBorderIcon from "@mui/icons-material/BookmarkBorder";

import ColouredSuitLogo from "../../../../Profile/TalentInfo/ColouredSuitLogo";
import dayjs from "dayjs";
import CloverCardStrip from "../../../../Profile/TalentInfo/CloverCardStrip";
import DiamondCardStrip from "../../../../Profile/TalentInfo/DiamondCardStrip";
import CoinTimeRating from "../../../../Profile/TalentInfo/CoinTimeRating";
import heart_card from "../../../../assets/heart_card.png";
import spade_card from "../../../../assets/spade_card.png";
import { useState } from "react";
import GuestSignInModal from "../../../../../pages/Auth/GuestSignInModal";
import { useAuth } from "../../../../../hooks";

interface Card {
  id: string;
  title: string;
  description: string;
  suit: string;
  categories?: string;
  price: number;
  duration: number;
  primary_thumbnail?: File | undefined | string | null;
  talent?: any;
  start_date_time?: string;
  gtp?: any;
}

interface CardContentProps {
  card: Card;
  bookmarkedCardIds: any;
  myDeckCardIds: any;
  onBookMark: any;
  isHovered: any;
  onAddtoDeck: any;
  onClickViewDetail: any;
  fromAddToDeck: any;
  isMobileViewModal?: boolean;
  product_type?: string;

  // talent
  isTalent?: boolean;
  onClickByTalent?: any;
}

export default function UserCardContents(props: CardContentProps) {
  const {
    bookmarkedCardIds,
    myDeckCardIds,
    onBookMark,
    card,
    isHovered,
    onAddtoDeck,
    onClickViewDetail,
    fromAddToDeck,
    isMobileViewModal = false,
    isTalent = false,
    onClickByTalent,
    product_type,
  } = props;

  const {
    title,
    description,
    suit,
    price,
    duration,
    primary_thumbnail,
    talent,
    start_date_time,
    gtp,
  } = card;

  const theme = useTheme();
  const isXs = useMediaQuery(theme.breakpoints.only("xs"));
  const isSm = useMediaQuery(theme.breakpoints.only("sm"));
  const isMd = useMediaQuery(theme.breakpoints.only("md"));
  const isLg = useMediaQuery(theme.breakpoints.only("lg"));
  const isXl = useMediaQuery(theme.breakpoints.only("xl"));
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const isBookmarked = bookmarkedCardIds?.includes(card.id);
  const isAddedToDeck = myDeckCardIds?.includes(card.id);

  // for guest login modal
  const { userInfo } = useAuth();
  const isGuest = userInfo ? false : true;
  // const isGuest = localStorage.getItem("isGuest") === "true" ? true : false;
  const [isGuestModalOpen, setIsGuestModalOpen] = useState(false);

  const getCardImage = (
    image?: string | File | null,
    suit?: string
  ): string => {
    if (typeof image === "string" && image.trim() !== "") return image;
    if (image instanceof Blob) return URL.createObjectURL(image);
    if (suit?.toLowerCase() === "heart") return heart_card;
    if (suit?.toLowerCase() === "spade") return spade_card;
    return "/image_4.jpg";
  };

  const date = dayjs(start_date_time).format("YYYY/MM/DD");
  const time = dayjs(start_date_time).format("HH:mm");

  const cardStrip = () => {
    if (suit === "Clover") {
      return (
        <CloverCardStrip
          chipAmount={price}
          isHovered={isHovered}
          time={time}
          date={date}
        />
      );
    } else if (suit === "Diamond") {
      return (
        <DiamondCardStrip
          rating="4.6"
          isHovered={isHovered}
          chipAmount={price}
          goods="file"
        />
      );
    } else {
      return (
        <CoinTimeRating
          chipAmount={price}
          duration={duration}
          rating="4.6"
          reviews="1 week ago"
          isHovered={isHovered}
        />
      );
    }
  };

  return (
    <Box
      role="group"
      aria-label={title}
      onClick={isTalent ? onClickByTalent : null}
      sx={{
        cursor: isTalent ? "pointer" : "default",
        width: {
          xs: "100%",
          sm: "100%",
          md: "100%",
        },
        maxWidth: {
          xxs: 340,
          xs: 360,
          sm: 360,
          md: 380,
        },
        // width: "auto",
        height: isMobileViewModal ? "auto" : "100%",
        position: "relative",
        borderRadius: "var(--spacing-3x)",
        // padding: "var(--spacing-4x)",
        padding: {
          xs: "var(--spacing-2x)",
          sm: "var(--spacing-3x)",
          md: "var(--spacing-4x)",
        },
        overflow: "hidden",
        backgroundColor: "#fff",
        border: "1px solid var(--neutral-100)",
        transition: "all 0.3s ease",
        boxShadow: isHovered && !isMobile ? "0 6px 16px rgba(0,0,0,0.15)" : "",
        transform: isHovered && !isMobile ? "scale(1.02)" : "scale(1)",
        marginTop: isMobileViewModal ? "10%" : "0px",
      }}
    >
      {!isMobile && !isTalent && (
        <Tooltip title={isBookmarked ? "Bookmarked" : "Add to Favorites"}>
          <IconButton
            onClick={() => onBookMark(card.id)}
            sx={{
              // padding: "4px",
              padding: {
                xs: "1px",
                sm: "3px",
                md: "4px",
              },
              position: "absolute",
              top: {
                xs: "15px",
                sm: "20px",
              },
              right: {
                xs: "15px",
                sm: "20px",
              },
              zIndex: "2",
              border: "1.5px solid",
              borderColor: isBookmarked ? "#10B981" : "#E5E7EB", // green if bookmarked
              // backgroundColor: isBookmarked
              //   ? alpha("#ECFDF5", 0.7) // 50% opacity green
              //   : alpha("#ffffff", 0.3), // 50% opacity white
              borderRadius: 2,
              backgroundColor: isBookmarked ? "#ECFDF5" : "#fff",
              "&:hover": {
                backgroundColor: isBookmarked ? "#D1FAE5" : "#f9f9f9",
              },
            }}
          >
            <BookmarkBorderIcon
              height={isXs || isSm ? "4px" : "16px"}
              width={isXs || isSm ? "4px" : "16px"}
              sx={{
                color: isBookmarked ? "#10B981" : "#6B7280",
                opacity: 1,
              }}
            />
          </IconButton>
        </Tooltip>
      )}
      {isMobileViewModal && (
        <Tooltip title={isBookmarked ? "Bookmarked" : "Add to Favorites"}>
          <IconButton
            onClick={() => onBookMark(card.id)}
            sx={{
              // padding: "4px",
              padding: {
                xs: "1px",
                sm: "3px",
                md: "4px",
              },
              position: "absolute",
              top: {
                xs: "15px",
                sm: "20px",
              },
              right: {
                xs: "15px",
                sm: "20px",
              },
              zIndex: "2",
              border: "1.5px solid",
              borderColor: isBookmarked ? "#10B981" : "#E5E7EB", // green if bookmarked
              backgroundColor: isBookmarked ? "#ECFDF5" : "#fff",
              borderRadius: 2,
              "&:hover": {
                backgroundColor: isBookmarked ? "#D1FAE5" : "#f9f9f9",
              },
            }}
          >
            <BookmarkBorderIcon
              height={isXs || isSm ? "4px" : "16px"}
              width={isXs || isSm ? "4px" : "16px"}
              sx={{ color: isBookmarked ? "#10B981" : "#6B7280" }}
            />
          </IconButton>
        </Tooltip>
      )}
      <Box
        component="img"
        src={getCardImage(primary_thumbnail, suit)}
        alt={title}
        onError={(e: any) => {
          e.target.onerror = null;
          e.target.src =
            "https://images.unsplash.com/photo-1575936123452-b67c3203c357?q=80&w=4740&auto=format&fit=crop";
        }}
        sx={{
          width: "100%",
          height: {
            xs: 160,
            sm: 180,
            md: 190,
            lg: 200,
            xl: 210,
          },
          objectFit: "cover",
          borderRadius: "var(--spacing-2x)",
        }}
      />
      <Box
        mt={{
          xs: "2px",
          sm: "5px",
          md: "12px",
        }}
      >
        <Stack
          direction={{ xs: "column", sm: "row" }}
          flexWrap="wrap"
          alignItems={{ xs: "flex-start", sm: "center" }}
          justifyContent="space-between"
          sx={{
            mb: 1,
            gap: {
              xs: "4px",
              sm: "5px",
              md: "12px",
            },
          }}
        >
          <ColouredSuitLogo suit={suit} />
          {suit === "Diamond" && product_type && (
            <Typography
              sx={{
                textWrap: "wrap",
                wordBreak: "break-word",
                font: "var(--semibold-xs)",
                backgroundColor: "var(--secondary-700)",
                color: "white",
                padding: "5px",
                borderRadius: "5px",
              }}
            >
              {product_type}
            </Typography>
          )}
        </Stack>

        {/* talent */}
        {/* {fromAddToDeck && ( */}

        {isHovered && !isMobile && !isTalent && (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              flexDirection: "row",
              mb: 3,
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "start",
                flexDirection: "row",
                gap: "10px",
                // mb: 1,
              }}
            >
              <Box
                component="img"
                height="40px"
                width="40px"
                sx={{ borderRadius: "100%", objectFit: "cover" }}
                src={gtp ? gtp?.profile_image : talent?.profile_image}
              ></Box>
              <Typography
                sx={{
                  font: {
                    xs: "var(--semibold-xs)",
                    md: "var(--semibold-sm)",
                  },
                }}
              >
                {gtp ? gtp?.name : talent?.username}
              </Typography>
            </Box>
          </Box>
        )}
        {isMobileViewModal && (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              flexDirection: "row",
              mb: 3,
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "start",
                flexDirection: "row",
                gap: "10px",
                // mb: 1,
              }}
            >
              <Box
                component="img"
                height="40px"
                width="40px"
                sx={{ borderRadius: "100%" }}
                src={talent?.profile_image}
              ></Box>
              <Typography
                sx={{
                  font: {
                    xs: "var(--semibold-xs)",
                    md: "var(--semibold-sm)",
                  },
                }}
              >
                {talent?.username}
              </Typography>
            </Box>
          </Box>
        )}

        <Typography
          variant="subtitle1"
          sx={{
            mb: "8px",
            color: "var(--neutral-1000)",
            font: "var(--semibold-md)",
            fontSize: {
              xs: "14px",
              sm: "14px",
              md: "16px",
            },
          }}
        >
          {title.length > 65 && !isHovered ? `${title.slice(0, 65)}...` : title}
        </Typography>

        {!fromAddToDeck && isHovered && !isMobile && (
          <Typography
            variant="body2"
            sx={{
              height: isHovered ? "auto" : 40,
              overflow: isHovered ? "visible" : "hidden",
              textOverflow: "ellipsis",
              mb: 2,
              font: "var(--body-sm)",
              color: "var(--neutral-600)",
              fontSize: {
                xs: "12px",
                sm: "14px",
              },
            }}
          >
            {description}
          </Typography>
        )}
        {isMobileViewModal && (
          <Typography
            variant="body2"
            sx={{
              height: isHovered ? "auto" : 40,
              overflow: isHovered ? "visible" : "hidden",
              textOverflow: "ellipsis",
              mb: 2,
              font: "var(--body-sm)",
              color: "var(--neutral-600)",
              fontSize: {
                xs: "12px",
                sm: "14px",
              },
            }}
          >
            {description}
          </Typography>
        )}

        {cardStrip()}

        {isHovered && !isMobile && !isTalent && (
          <Box
            sx={{
              transition: "all 0.3s ease",
              opacity: isHovered ? 1 : 0,
              transform: isHovered ? "translateY(0)" : "translateY(10px)",
            }}
          >
            {!isTalent && (
              <Stack
                direction={{ xs: "column", sm: "row" }}
                spacing={2}
                sx={{ mt: 2 }}
              >
                <Button
                  fullWidth
                  variant="outlined"
                  onClick={() =>
                    !isGuest ? onAddtoDeck(card.id) : setIsGuestModalOpen(true)
                  }
                  sx={{
                    font: {
                      sm: "var( --semibold-xs)",
                      md: "var( --semibold-sm)",
                    },
                    padding: "var(--spacing-3x)",
                    borderRadius: 3,
                    borderColor: isAddedToDeck ? "#10B981" : "#6366f1",
                    color: isAddedToDeck ? "#10B981" : "#6366f1",
                    textTransform: "none",
                    "&:hover": {
                      backgroundColor: isAddedToDeck ? "#D1FAE5" : "#eef2ff",
                      borderColor: isAddedToDeck ? "#10B981" : "#6366f1",
                    },
                  }}
                >
                  {isAddedToDeck ? "Remove from Deck" : "Add to Deck"}
                </Button>

                <Button
                  fullWidth
                  variant="outlined"
                  onClick={onClickViewDetail}
                  sx={{
                    font: {
                      sm: "var( --semibold-xs)",
                      md: "var( --semibold-sm)",
                    },
                    padding: "var(--spacing-3x)",
                    borderColor: "#6366f1",
                    color: "#6366f1",
                    borderRadius: 3,
                    textTransform: "none",
                    "&:hover": {
                      backgroundColor: "#eef2ff",
                      borderColor: "#6366f1",
                    },
                  }}
                >
                  Explore Card
                </Button>
              </Stack>
            )}
          </Box>
        )}
        {isMobileViewModal && (
          <Stack
            direction={{ xs: "column", sm: "row" }}
            spacing={2}
            sx={{ mt: 2 }}
          >
            <Button
              fullWidth
              variant="outlined"
              onClick={() =>
                !isGuest ? onAddtoDeck(card.id) : setIsGuestModalOpen(true)
              }
              sx={{
                font: "var( --semibold-xs)",
                borderRadius: 3,
                borderColor: isAddedToDeck ? "#10B981" : "#6366f1",
                color: isAddedToDeck ? "#10B981" : "#6366f1",
                textTransform: "none",
                "&:hover": {
                  backgroundColor: isAddedToDeck ? "#D1FAE5" : "#eef2ff",
                  borderColor: isAddedToDeck ? "#10B981" : "#6366f1",
                },
              }}
            >
              {isAddedToDeck ? "Remove from Deck" : "Add to Deck"}
            </Button>

            <Button
              fullWidth
              variant="outlined"
              onClick={onClickViewDetail}
              sx={{
                font: "var( --semibold-xs)",
                borderColor: "#6366f1",
                color: "#6366f1",
                borderRadius: 3,
                textTransform: "none",
                "&:hover": {
                  backgroundColor: "#eef2ff",
                  borderColor: "#6366f1",
                },
              }}
            >
              Explore Card
            </Button>
          </Stack>
        )}
      </Box>
      <GuestSignInModal
        open={isGuestModalOpen}
        onClose={() => setIsGuestModalOpen(false)}
      />
    </Box>
  );
}
